import { TIMER_TIMESTAMPS } from './constants';

/**
 * Formats time in milliseconds to a string in the format HH:MM:SS
 * @param timeMs Time in milliseconds
 * @returns Formatted time string
 */
export const formatTimeHMS = (timeMs: number): string => {
  const totalSeconds = Math.floor(timeMs / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  return [
    hours.toString().padStart(2, '0'),
    minutes.toString().padStart(2, '0'),
    seconds.toString().padStart(2, '0'),
  ].join(':');
};

/**
 * Formats time in milliseconds to a string in the format HH:MM:SS AM/PM
 * @param timeMs Time in milliseconds
 * @returns Formatted time string
 */
export const formatTimeAMPM = (timeMs: number): string => {
  const date = new Date(timeMs);
  const hours = date.getHours();
  const minutes = date.getMinutes();
  const seconds = date.getSeconds();
  const ampm = hours >= 12 ? 'PM' : 'AM';

  return (
    [
      (hours % 12 || 12).toString(),
      minutes.toString().padStart(2, '0'),
      seconds.toString().padStart(2, '0'),
    ].join(':') +
    ' ' +
    ampm
  );
};

/**
 * Increments a timer based on elapsed time
 * @param incrementer Function to update the timer value
 * @param incrementerCondition Condition to check before incrementing
 */
export const incrementTimer = (
  incrementer: (time: string) => void,
  incrementerCondition: boolean,
): void => {
  if (!incrementerCondition) return;

  // Mark the update point
  globalThis?.performance?.mark?.(TIMER_TIMESTAMPS.UPDATE_MARK);

  // Measure time between updates
  globalThis?.performance?.measure?.(
    TIMER_TIMESTAMPS.TIME_BETWEEN_UPDATES_MEASURE,
    TIMER_TIMESTAMPS.UPDATE_MARK,
  );

  // Get the elapsed time
  const timeElapsed =
    globalThis?.performance?.getEntriesByName?.(
      TIMER_TIMESTAMPS.TIME_BETWEEN_UPDATES_MEASURE,
    )?.[0]?.duration || 0;

  // Update the timer
  incrementer(formatTimeHMS(timeElapsed));
};
